<template>
    <div>
        <v-form ref="form" v-model="form.valid">
            <v-row justify="center">
                <v-col cols="12" md="6" lg="6" sm="12">
                    <v-row>
                        <v-col class="col-12" v-if="!showPrimary()">
                            <div class="question-field" >What will the GO Scholarship mean for your child and your family?  *</div>
                            <v-textarea class="text-area" outlined counter v-model="reference.What_will_the_GO_Scholarship_mean__c" :rules="lengthCheckMinMax" :maxlength="endorse_reason_max" />
                            <div class="helper-text ">Answer length: {{endorse_reason_min}} min - {{endorse_reason_max}} max (characters)</div>
                            <div class="helper-text ">Eg. Can now attend excursions, textbooks, tutoring.</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12" v-if="!showPrimary()">
                            <div class="question-field" >What hopes do you have for your child’s future?  *</div>
                            <v-textarea class="text-area" outlined counter v-model="reference.What_hopes_do_you_have_for_your_child__c" :rules="lengthCheckMinMax" :maxlength="endorse_reason_max" />
                            <div class="helper-text ">Answer length: {{endorse_reason_min}} min - {{endorse_reason_max}} max (characters)</div>   
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12">
                            <div class="question-field" >Are you aware of any circumstances that make it harder for your child to succeed at school?  *</div>
                            <v-textarea class="text-area" outlined counter v-model="reference.Circumstances_make_it_harder_for_child__c" :rules="lengthCheckMax" :maxlength="endorse_reason_max" />                            
                            <div class="helper-text ">Answer length: {{endorse_reason_max}} max (characters)</div>
                            <div class="helper-text " v-if="!showPrimary()">Eg. Drug use, alcohol use, family trauma.</div>
                            <div class="helper-text " v-if="showPrimary()">Eg. Family trauma, falling behind in school, difficulty socialising with other students</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12" v-if="showindependentquestion() && !showPrimary()">
                            <div class="question-field" >Why have you chosen this school?  *</div>
                            <v-textarea class="text-area" outlined counter v-model="reference.why_chosen_this_school__c" :rules="lengthCheckMinMax2" :maxlength="school_reason_max" />                            
                            <div class="helper-text ">Answer length: {{school_reason_min}} min - {{school_reason_max}} max (characters)</div>
                        </v-col>
                    </v-row>
                    <!--  >
                    <v-row>
                        <v-col class="col-12" v-if="showindependentquestion() && !showPrimary()">
                            <div class="question-field" >What is your estimated combined family income for this year?  *</div>
                            <v-text-field class="text-area" type="number" outlined counter v-model.number="reference.Combined_Family_Income_ThisYear__c" @keyup.native="InputNumber('Combined_Family_Income_ThisYear__c')"/>                            
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12" v-if="showindependentquestion() && !showPrimary()">
                            <div class="question-field" >What was your combined family income for last year?  *</div>
                            <v-text-field class="text-area" type="number" outlined counter v-model.number="reference.Combined_Family_Income_NextYear__c" @keyup.native="InputNumber('Combined_Family_Income_NextYear__c')"/>                            
                            <div class="helper-text ">Answer length: {{endorse_reason_max}} max (characters)</div>
                            <div class="helper-text ">Eg. Drug use, alcohol use, family trauma.</div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-12" v-if="showindependentquestion() && !showPrimary()">
                            <div class="question-field" >How much are you able to contribute to your child’s education each week?  *</div>
                            <v-text-field class="text-area" type="number" outlined counter v-model.number="reference.Contribute_To_Education__c"  @keyup.native="InputNumber('Contribute_To_Education__c')"/>                            
                            <div class="helper-text ">Answer length: {{endorse_reason_max}} max (characters)</div>
                            <div class="helper-text ">The GO Foundation asks that families contribute to the cost of tuition and extra activities for all independent school scholars. We do not dictate how much you contribute. We understand that every family is different, and every household has different burdens, so we do not want you to go without the necessities. However, we ask that any extra money go towards your child’s education. This way GO can provide scholarships to many more children. </div>
                        </v-col>
                    </v-row>
                    <  -->
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>
<script>
//import numberRule from '../../utils/validationRules' 

export default {
    data: function() {
        return {
            endorse_reason_min: 400,
            endorse_reason_max: 1000,
            school_reason_min: 250,
            school_reason_max: 400,
            school_type: '',
            school_level: '',
            //school_level: '',
        }
    },
    async beforeMount() {
        this.school_type = this.$store.getters['schtype/getschtype']['scholarshiptype'];
        this.school_level = this.$store.getters['schtype/getschtype']['schooltype'];
    },

    computed: {
        reference() {
            return this.$parent.reference
        },
        lengthCheckMinMax() {
            return [v => !v ? !!v || 'The field cannot be empty': v.length >= this.endorse_reason_min && v.length <= this.endorse_reason_max || 'Please check the length']
        },
        lengthCheckMax() {
            return [v => !v ? !!v || 'The field cannot be empty': v.length <= this.endorse_reason_max || 'Please check the length']
        },
        form() {
            return this.$parent.form
        },
        lengthCheckMinMax2() {
            return [v => !v ? !!v || 'The field cannot be empty': v.length >= this.school_reason_min && v.length <= this.school_reason_max || 'Please check the length']
        },
        notEmpty() {
            return [
                v => {
                    return v !== null
                        && v !== undefined
                        && JSON.parse(JSON.stringify(v)).length > 0;
                }
            ]
        }
        
        /*
        numberRules() {
            return [
                numberRule,
            ]            
        },*/
        
    },
    methods:{
        InputNumber (property) {
            console.log('into Inputnumber');
            this.reference[property] = this.limitInputNumber(this.reference[property]);
            console.log(this.reference[property]);
        },
        limitInputNumber (val) {
        if (val) {
            return String(val).replace(/\D/g, '')
        }
            return val
        },
        showindependentquestion() {

                this.school_type = this.$store.getters['schtype/getschtype']['scholarshiptype'];
                //console.log('In showinden  ' + this.school_type);
                //console.log('school type in endor' + this.school_type);
                //console.log('check detail and reference' );
                //console.log(this.detail);
                //console.log(this.reference);

            

            if(this.school_type.toLowerCase() == 'independent'){
                return true;
            }else{
                return false;
            }
        },
        showPrimary() {

            this.school_level = this.$store.getters['schtype/getschtype']['schooltype'];

            

            if(this.school_level.toLowerCase() == 'primary'){
                return true;
            }else{
                return false;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.primary-font{
    font-family: Hind;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
}

.text-area {
    @extend .primary-font;
}


.question-field{
    @extend .primary-font;
    font-size: 16px;
    line-height: 1.44;
    letter-spacing: normal;
    color: black;
    margin-bottom: 10px;
}

.helper-text {
  width: 620px;
  height: 18px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3a3a3a;
  margin-bottom: 20px;
}




</style>